// Chaves do `toDataModel` das classes de amortização do legado (UYZY e7f4d7b25,
// services/Amortization/types/amortizationModels.ts:5-186). Servem ao corpo do `POST /Amortization` da simulação
// e ao clonar/criar operação do `credit-note`: só as chaves da classe que existem no dado, na ordem da classe.

const BASIC = [
  'amortizationType',
  'startDate',
  'apr',
  'includePaymentFixedCosts',
  'requestedAmount',
  'financeTaxExempted',
  'agentCommission',
  'agentCommissions',
  'fiduciaryGuarantee',
  'indexer',
  'indexerValue',
  'calculateByValueType',
];
const AMORTIZATION = [
  ...BASIC,
  'paymentDay',
  'absAmortizationInMonths',
  'absInterestInMonths',
  'periodicity',
  'daysInYear',
  'firstPaymentInterest',
];
const SAC = [
  ...BASIC,
  'firstPaymentDate',
  'numberOfPayments',
  'numberOfInterestPayments',
  'calculationType',
  'paymentPeriodicity',
  'dueDateOnBusinessDays',
  'discountMode',
];
const CLEAN_PRICE = [...AMORTIZATION, 'termInMonths'];

/** `amortizationTypeMapping` (amortizationModels.ts:176-186): o tipo em minúsculas escolhe a classe. */
export const AMORTIZATION_KEYS: Readonly<Record<string, readonly string[]>> = {
  sac: SAC,
  price: SAC,
  cleanprice: CLEAN_PRICE,
  pricecoefficient: [...AMORTIZATION, 'dueDateOnBusinessDays', 'termInMonths'],
  receivablesprice: CLEAN_PRICE,
  studentloan: [
    ...AMORTIZATION,
    'termInMonths',
    'fixedPaymentDuringGraduation',
    'termsUntilGraduation',
    'absAfterGraduation',
  ],
  fgts: [...BASIC, 'termInMonths', 'paymentMonth'],
  discount: ['amortizationType', 'startDate', 'apr', 'futureValues'],
  receivablesadvance: [...BASIC, 'numberOfPayments', 'firstPaymentDate', 'periodicity'],
};

/**
 * `toDataModel` (validateAndPreparePayload.ts:1-15): copia só as chaves listadas que existem no dado (`in`, então
 * `undefined` e `null` presentes ficam), na ordem da lista.
 */
export function pickKeys(
  data: Readonly<Record<string, unknown>>,
  keys: readonly string[],
): Record<string, unknown> {
  const out: Record<string, unknown> = {};
  for (const key of keys) if (key in data) out[key] = data[key];
  return out;
}
